import React, { useEffect, useState } from "react";
import Info from "./common/info";
import { CompanyFormContainer, FormContainer, SettingContent } from "../styled/setting";
import { toast } from "react-toastify";
import Textarea from "./common/form/textarea";
import CompanyPreview from "./company/companyPreview";
import axios from "axios";

const CompanyInfo = ({ setActive, company, selectCompany, openModal, closeModal, getCompany }) => {
  const [formData, setFormData] = useState({});
  const message = company?.notice || company?.originInfo ? "수정" : "등록";

  useEffect(() => {
    setFormData(() => ({
      notice: company?.notice || "",
      originInfo: company?.originInfo || "",
    }));
  }, [company]);

  const closeForm = () => {
    setActive("menuBoard");
  };

  // 전체 유효성 검사
  const validationCheck = () => {
    return true;
  };

  const handleSave = () => {
    if (!validationCheck()) return;

    openModal({
      type: "confirmation",
      title: `공지사항·원산지 정보 ${message}`,
      message: [`변경하신 공지사항·원산지 정보를 ${message}하시겠습니까?`],
      handleConfirm: updateCompany,
    });
  };

  const updateCompany = async () => {
    try {
      const url = "/erp/ss/company/upsert";
      const body = {
        input: {
          cmpnyNo: selectCompany.value,
          notice: formData.notice,
          originInfo: formData.originInfo,
        },
      };

      await axios.post(url, body);
      toast.success("매장안내가 성공적으로 수정되었습니다.");
      setActive("menuBoard");
      getCompany(selectCompany);
    } catch (error) {
      console.error(error);
      toast.error("잠시 후 다시 시도해주세요");
    } finally {
      closeModal();
    }
  };

  const changeInput = (e) => {
    const { name, value } = e.target;
    setFormData((data) => ({ ...data, [name]: value }));
  };

  const textareaFields = [
    {
      label: "공지사항",
      name: "notice",
      placeholder: "공지사항을 입력해주세요. (최대 200자)",
      max: 200,
      onChange: changeInput,
    },
    {
      label: "원산지 정보",
      name: "originInfo",
      placeholder: "원산지 정보를 입력해주세요.",
      onChange: changeInput,
      tooltip: [
        {
          title: "원산지 표시",
          description: "판매하는 식품의 원재료나 재료의 원산지를 명확히 표시해야 합니다.",
          example: "예) 김치 (국산), 고추가루 (중국산)",
        },
      ],
    },
  ];

  return (
    <SettingContent>
      <Info
        message={`공지사항·원산지 정보 ${message}`}
        actions={[
          { label: "취소", func: closeForm, key: "cancel" },
          { label: "저장", func: handleSave, key: "add" },
        ]}
      />
      <CompanyFormContainer className="contents">
        <FormContainer>
          {textareaFields.map((field) => (
            <Textarea
              key={field.name}
              value={formData[field.name]}
              // readOnly={currentAuth === "VIEWER"}
              {...field}
            />
          ))}
        </FormContainer>
        <CompanyPreview
          company={company}
          activeTab={1}
          selectCompany={selectCompany}
          formData={formData}
          visibleMode="info"
        />
      </CompanyFormContainer>
    </SettingContent>
  );
};

export default CompanyInfo;
